"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NomosClient = void 0;
const cosmwasm_stargate_1 = require("@cosmjs/cosmwasm-stargate");
const communicator_1 = require("../communicator/communicator");
const cosmos_1 = require("../../utils/cosmos");
const cosmwasm_1 = require("../../types/cosmwasm");
class NomosClient extends cosmwasm_stargate_1.CosmWasmClient {
    constructor(tmClient) {
        super(tmClient);
        this.communicator = new communicator_1.PostMessageCommunicator(true);
    }
    static connect(endpoint) {
        return __awaiter(this, void 0, void 0, function* () {
            const cometClient = yield (0, cosmos_1.connectComet)(endpoint);
            return NomosClient.create(cometClient);
        });
    }
    static create(cometClient) {
        return __awaiter(this, void 0, void 0, function* () {
            return new NomosClient(cometClient);
        });
    }
    getChainId() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(cosmwasm_1.CosmwasmMethods.getChainId, {});
            return data.chainId;
        });
    }
    getHeight() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(cosmwasm_1.CosmwasmMethods.getHeight, {});
            return data.height;
        });
    }
    getAccount(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(cosmwasm_1.CosmwasmMethods.getAccount, { address });
            return data.account;
        });
    }
    getSequence(address) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('not implemented');
        });
    }
    getBlock(height) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(cosmwasm_1.CosmwasmMethods.getBlock, { height });
            return data.block;
        });
    }
    getBalance(address, searchDenom) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(cosmwasm_1.CosmwasmMethods.getBalance, {
                address,
                searchDenom,
            });
            return data.balance;
        });
    }
    getTx(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(cosmwasm_1.CosmwasmMethods.getTx, { id });
            return data.transaction;
        });
    }
    searchTx(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(cosmwasm_1.CosmwasmMethods.searchTx, { query });
            return data.transactions;
        });
    }
    broadcastTx(tx, timeoutMs = 60000, pollIntervalMs = 3000) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(cosmwasm_1.CosmwasmMethods.broadcastTx, {
                tx,
                timeoutMs,
                pollIntervalMs,
            });
            return data.response;
        });
    }
    broadcastTxSync(tx) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(cosmwasm_1.CosmwasmMethods.broadcastTxSync, {
                tx,
            });
            return data.txHash;
        });
    }
    getCodes() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(cosmwasm_1.CosmwasmMethods.getCodes, {});
            return data.codes;
        });
    }
    getCodeDetails(codeId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(cosmwasm_1.CosmwasmMethods.getCodeDetails, {
                codeId,
            });
            return data.details;
        });
    }
    getContracts(codeId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(cosmwasm_1.CosmwasmMethods.getContracts, {
                codeId,
            });
            return data.contracts;
        });
    }
    getContractsByCreator(creator) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(cosmwasm_1.CosmwasmMethods.getContractsByCreator, {
                creator,
            });
            return data.contracts;
        });
    }
    getContract(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(cosmwasm_1.CosmwasmMethods.getContract, {
                address,
            });
            return data.contract;
        });
    }
    getContractCodeHistory(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(cosmwasm_1.CosmwasmMethods.getContractCodeHistory, {
                address,
            });
            return data.historyEntries;
        });
    }
    queryContractRaw(address, key) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(cosmwasm_1.CosmwasmMethods.queryContractRaw, {
                address,
                key,
            });
            return data.rawData;
        });
    }
    queryContractSmart(address, queryMsg) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(cosmwasm_1.CosmwasmMethods.queryContractSmart, {
                address,
                queryMsg,
            });
            return data.smartQuery;
        });
    }
}
exports.NomosClient = NomosClient;
//# sourceMappingURL=nomosClient.js.map